export const AR = 'ar';
export const EN = 'en';

export type LocalizationTypes = typeof AR | typeof EN;
